import React from 'react';
import {
  bool, func, string, arrayOf, exact, number,
} from 'prop-types';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { Flex, Typography } from '@atoms';
import { Edit } from '@templates';
import { DraggableItems } from '@organisms';

const CategoriesOrder = ({
  isConfirmButtonDisabled,
  onDragCategoryEnd,
  categories,
  isLoading,
  onToastClose,
  onEditSubmit,
  onEditCancel,
  hasServerError,
}) => (
  <Edit
    isConfirmButtonDisabled={isConfirmButtonDisabled}
    isLoading={isLoading}
    onToastClose={onToastClose}
    onEditCancel={onEditCancel}
    onEditSubmit={onEditSubmit}
    hasServerError={hasServerError}
  >
    <Flex column paddingTop="xl5" paddingBottom="xl5">
      <Typography marginBottom="xl3" size="xl2" weight="black">
        Change the order of the categories
      </Typography>
      <DragDropContext onDragEnd={onDragCategoryEnd}>
        <Droppable droppableId="categories">
          {provided => (
            <Flex column ref={provided.innerRef} {...provided.droppableProps}>
              <DraggableItems items={categories} />
              {provided.placeholder}
            </Flex>
          )}
        </Droppable>
      </DragDropContext>
    </Flex>
  </Edit>
);

CategoriesOrder.propTypes = {
  isConfirmButtonDisabled: bool.isRequired,
  onDragCategoryEnd: func.isRequired,
  categories: arrayOf(exact({
    name: string,
    id: number,
  })).isRequired,
  onToastClose: func.isRequired,
  hasServerError: bool.isRequired,
  isLoading: bool.isRequired,
  onEditSubmit: func.isRequired,
  onEditCancel: func.isRequired,
};

export default CategoriesOrder;
